import type { IsolatedPartnerPointsPerPair } from '@/config/chain/types'

export interface PointsDisplayInfo {
  multiplier?: number
  partnerPoints?: IsolatedPartnerPointsPerPair[]
}

interface ResolvePointsDisplayParams {
  entryPartnerPoints?: IsolatedPartnerPointsPerPair[]
  pointsInfo?: PointsDisplayInfo
  isEarnVault: boolean
}

export interface ResolvedPointsDisplay {
  partnerPoints: IsolatedPartnerPointsPerPair[]
  isEarnVault: boolean
  hasHypurrPoints: boolean
  hasPartnerPoints: boolean
  hasAnyPoints: boolean
}

export function resolvePointsDisplay({
  entryPartnerPoints,
  pointsInfo,
  isEarnVault,
}: ResolvePointsDisplayParams): ResolvedPointsDisplay {
  const partnerPoints = entryPartnerPoints || pointsInfo?.partnerPoints || []
  const hasHypurrPoints = pointsInfo?.multiplier !== undefined
  const hasPartnerPoints = partnerPoints.length > 0

  return {
    partnerPoints,
    isEarnVault,
    hasHypurrPoints,
    hasPartnerPoints,
    hasAnyPoints: hasHypurrPoints || hasPartnerPoints || isEarnVault,
  }
}
